import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BASE_URL } from '../../insightConfig/insightConfig';
import "./Buttontab.css";

function Buttontabs({ componentName, setContentToShow, ContentToShow, showAlert, handlelocal }) {
    // Manage All button State
    const [activeButton, setActiveButton] = useState('In News'); //Track active button
    const [buttonNames, setButtonNames] = useState([]); //Manage All button Name Array
    const navigate = useNavigate();
    const location = useLocation();
    const [currenttab, setcurrenttab] = useState(() => {
        const storedAuthToken = localStorage.getItem('currenttabarray');
        return storedAuthToken ? JSON.parse(storedAuthToken) : [];
    })
    useEffect(() => {

        if (componentName) {
            fetch(`${BASE_URL}/current-affairs-category-names`)
                .then(response => response.json())
                .then(data => {
                    const carray = data.data || []
                    setcurrenttab(data.data);
                    localStorage.setItem('currenttabarray', JSON.stringify(carray));

                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
        // Map component names to button labels
        const buttonLabels = {
            // 'currentaffairs': ['In News', 'Editorial', 'Yojana', 'Big Picture', 'Insight Radio'],
            'currentaffairs': currenttab,
            'Blog': ['Blogs', "Today's Special"],
            'Prelims': ["START"],
            'WithPrelimsQuit': ["CONTINUE"],
            'WithPrelims': ["REATTEMPT", "VIEW REPORT"],
            'Cuet': ['CUET', 'Language Subjects', 'Domain-Specific Subjects', 'General Aptitude Test', 'RESOURCES'/* , 'PRACTICE QUIZ' */],
            // 'ugc_net': ['ABOUT', 'GENERAL APTITUDE', 'SUBJECT SPECIFIC', 'COMBINED', 'SYLLABUS', 'RESOURCES'],
            'ugc_net': [
                'ABOUT',
                'GENERAL APTITUDE',
                'SUBJECT SPECIFIC',
                'COMBINED',
                'SYLLABUS',
                'RESOURCES'
            ],
            'neet': ['Home', 'Classes', 'Test Series', 'All Subjects Test', 'Resources'],
            // Add more component names and their associated button labels as needed
        };
        const defaultButtons = buttonLabels['civilHistory']; // Default to currentaffairs if componentName doesn't match
        const buttons = buttonLabels[componentName] || defaultButtons;
        // Manage Default State of Feature and Overview Content According to ComponentName
        switch (componentName) {
            case 'currentaffairs':
                setContentToShow('In News');
                break;
            case 'Blog':
                setContentToShow('Blogs');
                break;
            case 'PT MCQs':
                setContentToShow('PT MCQs');
                setActiveButton('PT MCQs');
                break;
            default:
                break;
        }
        setButtonNames(buttons);

        // Auto-detect active button from URL path for ugc_net to support unified SPA navigation
        const path = location.pathname;
        if (componentName === 'ugc_net') {
            if (path.includes('/dynamic-testseries/general-aptitude')) {
                setActiveButton('generalaptitude');
            } else if (path.includes('/dynamic-testseries/subject-specific')) {
                setActiveButton('subjectspecific');
            } else if (path.includes('/dynamic-testseries/combined')) {
                setActiveButton('combined');
            } else if (path.includes('/syllabus')) {
                setActiveButton('syllabus');
            } else if (path.includes('/resources')) {
                setActiveButton('resources');
            } else {
                setActiveButton('about');
            }
        } else {
            setActiveButton(buttons[0]?.toLowerCase()?.replace(/\s+/g, '') || '');
        }
    }, [componentName, location.pathname]);

    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName.toLowerCase().replace(/\s+/g, ''));
    };

    return (
        <>
            {/*Button tab Section Start */}
            <div className='buttontab-background'>
                {componentName !== 'Cuet' && componentName !== 'Blog' && componentName !== 'neet' && componentName !== 'Prelims' && componentName !== 'WithPrelims' && componentName !== 'WithPrelimsQuit' && componentName !== 'ugc_net' &&
                    <div className='p-3'>
                        <div className="buttontab-Container">
                            {buttonNames.map((name, index) => (
                                <button
                                    key={index}
                                    className={`btn btn-margin ${activeButton === name.toLowerCase().replace(/\s+/g, '') ? 'activebuttontab' : "bgtab-white"}`}
                                    onClick={
                                        () => {
                                            handleButtonClick(name)
                                            switch (name) {
                                                case 'In News':
                                                    // Handle In News accordingly
                                                    setContentToShow('In News');
                                                    break;
                                                case 'Editorial':
                                                    // Handle Editorial accordingly
                                                    setContentToShow('Editorial');
                                                    break;
                                                case 'Yojana':
                                                    // Handle Yojana accordingly
                                                    setContentToShow('Yojana');
                                                    break;
                                                case 'Big Picture':
                                                    // Handle Big Picture accordingly
                                                    setContentToShow('Big Picture');
                                                    break;
                                                case 'Insight Radio':
                                                    // Handle Insight Radio accordingly
                                                    setContentToShow('Insight Radio');
                                                    break;
                                                case 'Blogs':
                                                    // Handle Blogs accordingly
                                                    setContentToShow('Blogs');
                                                    break;
                                                case "Today's Special":
                                                    // Handle Today's Special accordingly
                                                    setContentToShow("Today's Special");
                                                    break;
                                                case "PT MCQs":
                                                    // Handle PT MCQs accordingly
                                                    setContentToShow("PT MCQs");
                                                    break;
                                                case "START":
                                                    // Handle START accordingly
                                                    setContentToShow("START");
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                    }
                                    type="button">{name == 'CUET' ? <span style={{ borderBottom: "2px solid #a54a06", color: '#a54a06' }}>{name}</span> : name}</button>
                            ))}
                        </div>
                    </div>
                }
                {componentName === 'Prelims' && componentName !== 'WithPrelims' && componentName !== 'WithPrelimsQuit' &&
                    <div className='p-3'>
                        <div className="buttontab-Container">
                            {buttonNames.map((name, index) => (
                                <>
                                    <button
                                        key={index}
                                        className={`btn btn-prelims-margin activebuttontabmcq`}
                                        type="button">PT MCQs</button>
                                    <button
                                        key={index}
                                        className={`btn btn-prelims-margin ${activeButton === ContentToShow ? 'activebuttontabmcq' : 'bgtab-mcq'}`}
                                        onClick={
                                            () => {
                                                handleButtonClick(name)
                                                switch (name) {
                                                    case 'In News':
                                                        // Handle In News accordingly
                                                        setContentToShow('In News');
                                                        break;
                                                    case 'Editorial':
                                                        // Handle Editorial accordingly
                                                        setContentToShow('Editorial');
                                                        break;
                                                    case 'Yojana':
                                                        // Handle Yojana accordingly
                                                        setContentToShow('Yojana');
                                                        break;
                                                    case 'Big Picture':
                                                        // Handle Big Picture accordingly
                                                        setContentToShow('Big Picture');
                                                        break;
                                                    case 'Insight Radio':
                                                        // Handle Insight Radio accordingly
                                                        setContentToShow('Insight Radio');
                                                        break;
                                                    case 'Blogs':
                                                        // Handle Blogs accordingly
                                                        setContentToShow('Blogs');
                                                        break;
                                                    case "Today's Special":
                                                        // Handle Today's Special accordingly
                                                        setContentToShow("Today's Special");
                                                        break;
                                                    case "PT MCQs":
                                                        // Handle PT MCQs accordingly
                                                        setContentToShow("PT MCQs");
                                                        break;
                                                    case "START":
                                                        // Handle START accordingly
                                                        setContentToShow("START");
                                                        showAlert()
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }
                                        }
                                        type="button">{name}</button>
                                </>
                            ))}
                        </div>
                    </div>
                }
                {componentName === 'WithPrelims' && componentName !== 'Prelims' && componentName !== 'WithPrelimsQuit' &&
                    <div className='p-3'>
                        <div className="buttontab-Container">
                            <button
                                className={`btn btn-prelims-margin activebuttontabmcq`}
                                type="button">PT MCQs</button>
                            {buttonNames.map((name, index) => (
                                <>
                                    <button
                                        key={index}
                                        className={`btn btn-prelims-margin ${activeButton === ContentToShow ? 'bg-Question-white' : 'bg-Question-white'}`}
                                        onClick={
                                            () => {
                                                handleButtonClick(name)
                                                switch (name) {
                                                    case 'In News':
                                                        // Handle In News accordingly
                                                        setContentToShow('In News');
                                                        break;
                                                    case 'Editorial':
                                                        // Handle Editorial accordingly
                                                        setContentToShow('Editorial');
                                                        break;
                                                    case 'Yojana':
                                                        // Handle Yojana accordingly
                                                        setContentToShow('Yojana');
                                                        break;
                                                    case 'Big Picture':
                                                        // Handle Big Picture accordingly
                                                        setContentToShow('Big Picture');
                                                        break;
                                                    case 'Insight Radio':
                                                        // Handle Insight Radio accordingly
                                                        setContentToShow('Insight Radio');
                                                        break;
                                                    case 'Blogs':
                                                        // Handle Blogs accordingly
                                                        setContentToShow('Blogs');
                                                        break;
                                                    case "Today's Special":
                                                        // Handle Today's Special accordingly
                                                        setContentToShow("Today's Special");
                                                        break;
                                                    case "PT MCQs":
                                                        // Handle PT MCQs accordingly
                                                        setContentToShow("PT MCQs");
                                                        break;
                                                    case "REATTEMPT":
                                                        // Handle START accordingly
                                                        setContentToShow("REATTEMPT");
                                                        showAlert()
                                                        handlelocal()
                                                        break;
                                                    case "CONTINUE":
                                                        // Handle START accordingly
                                                        setContentToShow("CONTINUE");
                                                        showAlert()
                                                        break;
                                                    case "VIEW REPORT":
                                                        // Handle START accordingly
                                                        setContentToShow("VIEW REPORT");
                                                        navigate('/CourseDescreption/CourseResult')
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }
                                        }
                                        type="button">{name}</button>
                                </>
                            ))}
                        </div>
                    </div>
                }
                {componentName === 'WithPrelimsQuit' && componentName !== 'Prelims' && componentName !== 'WithPrelims' &&
                    <div className='p-3'>
                        <div className="buttontab-Container">
                            <button
                                className={`btn btn-prelims-margin activebuttontabmcq`}
                                type="button">PT MCQs</button>
                            {buttonNames.map((name, index) => (
                                <>
                                    <button
                                        key={index}
                                        className={`btn btn-prelims-margin ${activeButton === ContentToShow ? 'bg-Question-white' : 'bg-Question-white'}`}
                                        onClick={
                                            () => {
                                                handleButtonClick(name)
                                                switch (name) {
                                                    case 'In News':
                                                        // Handle In News accordingly
                                                        setContentToShow('In News');
                                                        break;
                                                    case 'Editorial':
                                                        // Handle Editorial accordingly
                                                        setContentToShow('Editorial');
                                                        break;
                                                    case 'Yojana':
                                                        // Handle Yojana accordingly
                                                        setContentToShow('Yojana');
                                                        break;
                                                    case 'Big Picture':
                                                        // Handle Big Picture accordingly
                                                        setContentToShow('Big Picture');
                                                        break;
                                                    case 'Insight Radio':
                                                        // Handle Insight Radio accordingly
                                                        setContentToShow('Insight Radio');
                                                        break;
                                                    case 'Blogs':
                                                        // Handle Blogs accordingly
                                                        setContentToShow('Blogs');
                                                        break;
                                                    case "Today's Special":
                                                        // Handle Today's Special accordingly
                                                        setContentToShow("Today's Special");
                                                        break;
                                                    case "PT MCQs":
                                                        // Handle PT MCQs accordingly
                                                        setContentToShow("PT MCQs");
                                                        break;
                                                    case "REATTEMPT":
                                                        // Handle START accordingly
                                                        setContentToShow("REATTEMPT");
                                                        showAlert()
                                                        handlelocal()
                                                        break;
                                                    case "CONTINUE":
                                                        // Handle START accordingly
                                                        setContentToShow("CONTINUE");
                                                        showAlert()
                                                        break;
                                                    case "VIEW REPORT":
                                                        // Handle START accordingly
                                                        setContentToShow("VIEW REPORT");
                                                        navigate('/CourseDescreption/CourseResult')
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }
                                        }
                                        type="button">{name}</button>
                                </>
                            ))}
                        </div>
                    </div>
                }
                {componentName === 'Cuet' &&
                    <div className='p-3'>
                        <div className="buttoncuettab-Container">
                            {buttonNames.map((name, index) => (
                                <button
                                    key={index}
                                    style={name == 'CUET' ? { borderBottom: "2px solid white" } : {}}
                                    className={`btn btncuet-margin fw-bold ${activeButton === name.toLowerCase().replace(/\s+/g, '') ? 'activecuetbuttontab' : "bgcuettab-white"}`}
                                    onClick={
                                        () => {
                                            handleButtonClick(name)
                                            switch (name) {
                                                case 'In News':
                                                    // Handle In News accordingly
                                                    setContentToShow('In News');
                                                    break;
                                                case 'Editorial':
                                                    // Handle Editorial accordingly
                                                    setContentToShow('Editorial');
                                                    break;
                                                case 'Yojana':
                                                    // Handle Yojana accordingly
                                                    setContentToShow('Yojana');
                                                    break;
                                                case 'Big Picture':
                                                    // Handle Big Picture accordingly
                                                    setContentToShow('Big Picture');
                                                    break;
                                                case 'Insight Radio':
                                                    // Handle Insight Radio accordingly
                                                    setContentToShow('Insight Radio');
                                                    break;
                                                case 'Blogs':
                                                    // Handle Blogs accordingly
                                                    setContentToShow('Blogs');
                                                    break;
                                                case "Today's Special":
                                                    // Handle Today's Special accordingly
                                                    setContentToShow("Today's Special");
                                                    break;
                                                case "PT MCQs":
                                                    // Handle PT MCQs accordingly
                                                    setContentToShow("PT MCQs");
                                                    break;
                                                case "START":
                                                    // Handle START accordingly
                                                    setContentToShow("START");
                                                    break;
                                                case "CUET":
                                                    // Handle START accordingly
                                                    setContentToShow("CUET");
                                                    // setcuetlink("#")
                                                    break;
                                                case "Language Subjects":
                                                    // Handle START accordingly
                                                    setContentToShow("Language Subjects");
                                                    // setcuetlink("/cuet/prelims-test-series-for-upsc")
                                                    navigate('/cuet/Language-Subjects')
                                                    break;
                                                case "Domain-Specific Subjects":
                                                    // Handle START accordingly
                                                    setContentToShow("Domain-Specific Subjects");
                                                    // setcuetlink("/cuet/Pre-Cum-Mains-Test-Series")
                                                    navigate('/cuet/Domain-Specific-Subjects')
                                                    break;
                                                case "General Aptitude Test":
                                                    // Handle START accordingly
                                                    setContentToShow("General Aptitude Test");
                                                    navigate('/cuet/General-Aptitude-Test');
                                                    // setcuetlink("#")
                                                    break;
                                                case "RESOURCES":
                                                    navigate('/cuet/resources');
                                                    setContentToShow("CUET SECTION – III");
                                                    // setcuetlink("#")
                                                    break;
                                                case "PRACTICE QUIZ":
                                                    // Handle START accordingly
                                                    setContentToShow("PRACTICE QUIZ");
                                                    // setcuetlink("#")
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                    }
                                    type="button">{name == 'CUET' ? <span style={{ color: 'white', width: "100%" }}>Home <br></br><span style={{ borderTop: "2px solid white", width: "100%", fontSize: "0.8em" }}>Exam Pattern</span></span> : name}</button>
                            ))}
                        </div>
                    </div>
                }
                {componentName === 'ugc_net' &&
                    <div className='p-3'>
                        <div className="buttoncuettab-Container">
                            {buttonNames.map((name, index) => (
                                <button
                                    key={index}
                                    style={name === 'ABOUT' || name === 'GENERAL APTITUDE' || name === 'SUBJECT SPECIFIC' || name === 'COMBINED' ? { borderBottom: "2px solid white" } : {}}
                                    className={`btn btncuet-margin fw-bold ${activeButton === name.toLowerCase().replace(/\s+/g, '') ? 'activecuetbuttontab' : "bgcuettab-white"}`}
                                    onClick={
                                        () => {
                                            handleButtonClick(name)
                                            switch (name) {
                                                case 'RESOURCES':
                                                    navigate('/ugc-net/resources');
                                                    break;
                                                case 'GENERAL APTITUDE':
                                                    navigate('/ugc-net/dynamic-testseries/general-aptitude', { state: { subject: 'GENERAL APTITUDE' } });
                                                    break;
                                                case 'SUBJECT SPECIFIC':
                                                    navigate('/ugc-net/dynamic-testseries/subject-specific');
                                                    break;
                                                case 'COMBINED':
                                                    navigate('/ugc-net/dynamic-testseries/combined', { state: { subject: 'COMBINED' } });
                                                    break;
                                                case 'SYLLABUS':
                                                    navigate('/ugc-net/syllabus');
                                                    break;
                                                case 'ABOUT':
                                                    navigate('/ugc-net');
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                    }
                                    type="button">{
                                        name === 'ABOUT' ? <span style={{ color: 'white', width: "100%" }}>Home <br></br><span style={{ borderTop: "2px solid white", width: "100%", fontSize: "0.8em" }}>Exam Pattern</span></span> :
                                            name === 'GENERAL APTITUDE' ? <span style={{ color: 'white', width: "100%" }}>Teaching & Research <br></br><span style={{ borderTop: "2px solid white", width: "100%", fontSize: "0.8em" }}>Aptitude</span></span> :
                                                name === 'SUBJECT SPECIFIC' ? <span style={{ color: 'white', width: "100%" }}>Domain Subjects <br></br><span style={{ borderTop: "2px solid white", width: "100%", fontSize: "0.8em" }}>Academic Subjects</span></span> :
                                                    name === 'COMBINED' ? <span style={{ color: 'white', width: "100%" }}>Combined <br></br><span style={{ borderTop: "2px solid white", width: "100%", fontSize: "0.8em" }}>Simulated Tests</span></span> :
                                                        name === 'SYLLABUS' ? <span style={{ color: 'white', width: "100%" }}>Syllabus</span> :
                                                            name === 'RESOURCES' ? <span style={{ color: 'white', width: "100%" }}>Resources</span> :
                                                                name
                                    }</button>
                            ))}
                        </div>
                    </div>
                }
                {componentName === 'neet' &&
                    <div className='p-3'>
                        <div className="buttoncuettab-Container">
                            {buttonNames.map((name, index) => {
                                return <button
                                    key={index}
                                    style={name == 'Home' ? { borderBottom: "2px solid white" } : {}}
                                    className={`btn btncuet-margin fw-bold ${activeButton === name.toLowerCase().replace(/\s+/g, '') ? 'activecuetbuttontab' : "bgcuettab-white"}`}
                                    onClick={
                                        () => {
                                            handleButtonClick(name);
                                            switch (name) {
                                                case 'Home':
                                                    navigate('/neet/about');
                                                    break;
                                                case 'Classes':
                                                    navigate('/neet/classes');
                                                    break;
                                                case 'Resources':
                                                    navigate('/neet/study-material');
                                                    break;
                                                case 'Test Series':
                                                    navigate('/neet/testseries');
                                                    break;
                                                case 'All Subjects Test':
                                                    navigate('/neet/All-Subjects');
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                    }
                                    type="button">{name == 'Home' ? <span style={{ color: 'white', width: "100%" }}>Home <br></br><span style={{ borderTop: "2px solid white", width: "100%", fontSize: "0.8em" }}>Exam Pattern</span></span> : name}</button>
                            })}
                        </div>
                    </div>
                }
                {componentName === 'Blog' &&
                    <div className='pt-3'>
                        <div className="buttoncuettab-Container">
                            {buttonNames.map((name, index) => (
                                <button
                                    key={index}
                                    className={`btn btncuet-margin ${activeButton === name.toLowerCase().replace(/\s+/g, '') ? 'activeblogbuttontab' : "bgblogtab-white"}`}
                                    onClick={
                                        () => {
                                            handleButtonClick(name)
                                            switch (name) {
                                                case 'In News':
                                                    // Handle In News accordingly
                                                    setContentToShow('In News');
                                                    break;
                                                case 'Editorial':
                                                    // Handle Editorial accordingly
                                                    setContentToShow('Editorial');
                                                    break;
                                                case 'Yojana':
                                                    // Handle Yojana accordingly
                                                    setContentToShow('Yojana');
                                                    break;
                                                case 'Big Picture':
                                                    // Handle Big Picture accordingly
                                                    setContentToShow('Big Picture');
                                                    break;
                                                case 'Insight Radio':
                                                    // Handle Insight Radio accordingly
                                                    setContentToShow('Insight Radio');
                                                    break;
                                                case 'Blogs':
                                                    // Handle Blogs accordingly
                                                    setContentToShow('Blogs');
                                                    break;
                                                case "Today's Special":
                                                    // Handle Today's Special accordingly
                                                    setContentToShow("Today's Special");
                                                    break;
                                                case "PT MCQs":
                                                    // Handle PT MCQs accordingly
                                                    setContentToShow("PT MCQs");
                                                    break;
                                                case "START":
                                                    // Handle START accordingly
                                                    setContentToShow("START");
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                    }
                                    type="button">{name}</button>
                            ))}
                        </div>
                    </div>
                }
            </div>
            {/*Button tab Section End */}
        </>
    )
}

export default Buttontabs;